define('models/EstimatedTimeModel',['jquery','underscore','backbone','ObjectModel','LocalStorage','router','app','ApiRequest'],function ($,_,Backbone,ObjectModel,LocalStorage,router,app,ApiRequest) {
    //
    // Model EstimatedTime
    //
    var EstimatedTimeModelPrototype = {
        
        name:'EstimatedTimeModel',
        route:'apiEstimatedTime',
        //
        defaults:{
            sync:false
        },
        //
        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
            this.softFetch();
            //
        },
        idAttribute:function(){
            return this.get('id_store')+'_'+this.get('id_postcode');
        },
        getDelayMinMax:function(isVAE){
            var model = this,type = isVAE == true ? 'vae':'vad',
                min = model.get('delay_min_'+type),
                max = model.get('delay_max_'+type);
                if(min && max) {
                    return {
                        min: min, max: max
                    };
                }else{
                    return 'loading';
                }
        },
        getLocalStorageKey:function(){
            var model = this,
                key = model.name+'_'+model.get('id_store')+'_'+model.get('id_postcode');
            return key;
        },
        isSync:function(){
            return this.get('sync');
        },
        remoteFetch:function(){
            var model = this;
            this.isRemoteFetching = true;
            $.ajax({
                url:model.url(),
                data:{
                    id_store:model.get('id_store'),
                    id_postcode:model.get('id_postcode')
                },
                contentType:'application/x-www-form-urlencoded; charset=UTF-8',
                dataType:'json'
            }).done(function(data,success,xhr){
                data.sync = true;
                model.set(data);
                model.trigger('sync',model,data,{xhr:xhr});
            }).fail(function(){
                this.isRemoteFetching = false;
            })
        },
        url:function(){
            return router.getApiRouteUrl(this.route)({iso_lang:app.getIsoLang()});
        }
    };

    var EstimatedTimeModel = ObjectModel.extend(LocalStorage).extend(EstimatedTimeModelPrototype);
    
    EstimatedTimeModel.resetAllDelays = function(){
        estimatedTimeCollection.reset();
        LocalStorage.removeAllItemsOfType(EstimatedTimeModelPrototype.name);
    };

    // static private Collection of all EstimatedTime
    var estimatedTimeCollection = new Backbone.Collection();
    EstimatedTimeModel.getModel = function(where){
        var existingEstimatedTime = estimatedTimeCollection.findWhere(where);
        if(_.isUndefined(existingEstimatedTime)){
            var estimatedTime = new EstimatedTimeModel(where);
            estimatedTimeCollection.add(estimatedTime);
            return estimatedTime;
        }
        return existingEstimatedTime;    
    };
    
    return EstimatedTimeModel;
});
